<template>
    <div class="list-page-shell">
        <div v-if="title" class="list-page-shell__heading">{{ title }}</div>
        <p v-if="hint" class="list-page-shell__hint">{{ hint }}</p>
        <slot />
    </div>
</template>

<script>
export default {
    name: 'ListPageShell',
    props: {
        title: {
            type: String,
            default: ''
        },
        hint: {
            type: String,
            default: ''
        }
    }
};
</script>

<style scoped>
.list-page-shell {
    padding: 18px;
}

.list-page-shell__heading {
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
}

.list-page-shell__hint {
    margin: 0 0 16px;
    font-size: 13px;
    color: #909399;
    line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ListPageShell.vue